export default {
	googleMapsAPIKey: 'AIzaSyAcFPNDde5JikaizW8d6YjR-nsHCwABR9E',
};
